import { useState, useRef } from 'react';
import { useAppStore } from '../../../GlobalStore/GlobalStore.ts';
import { writeSettings } from '../../../Utils/db/users/userSettings/writeSettings.ts';
import { getContextModeIcon } from './modalityConfig';
import ModalityExpanded from './ModalityExpanded';

const ModalitySelector = () => {
    const settingsObj = useAppStore((state: any) => state.settingsObj);
    const setSettingsObj = useAppStore((state: any) => state.setSettingsObj);
    const userObj = useAppStore((state: any) => state.userObj);
    const environmentObj = useAppStore((state: any) => state.environmentObj);

    const { contextMode = 'Text + Image' } = settingsObj;
    const { environment } = environmentObj;

    const [isExpanded, setIsExpanded] = useState(false);
    const containerRef = useRef<HTMLDivElement>(null);

    const ContextModeIcon = getContextModeIcon(contextMode);

    const handleContextModeChange = (newContextMode: string) => {
        if (userObj.user) {
            writeSettings(userObj.user, { contextMode: newContextMode }, environment);
        }
        setSettingsObj({ contextMode: newContextMode });
        setIsExpanded(false);
    };

    return (
        <div
            ref={containerRef}
            className="relative flex items-center"
            onMouseEnter={() => setIsExpanded(true)}
            onMouseLeave={() => setIsExpanded(false)}
        >
            {/* Main context mode button */}
            <div className="flex items-center justify-center w-8 h-8 bg-gray-200 dark:bg-neutral-800 text-neutral-700 dark:text-neutral-200 rounded-full hover:bg-gray-300 dark:hover:bg-neutral-700 cursor-pointer">
                <ContextModeIcon size={16} />
            </div>

            {/* Invisible bridge to prevent hover gaps */}
            <div className={`absolute bottom-8 left-1/2 transform -translate-x-1/2 w-32 h-8 cursor-pointer ${isExpanded ? '' : 'pointer-events-none'}`} />

            {/* Expanded context mode options */}
            <ModalityExpanded
                isExpanded={isExpanded}
                currentContextMode={contextMode}
                onContextModeChange={handleContextModeChange}
            />
        </div>
    );
};

export default ModalitySelector;